import React from 'react';

import type { DropdownSection, RichNavItem } from '../types';

interface LayeredMenuProps {
  sections: DropdownSection[];
}

function isSectionRich(items: RichNavItem[]): boolean {
  return items.some(
    (item) => item.icon || item.stockblocksIcon || item.description
  );
}

export default function LayeredMenu({
  sections,
}: LayeredMenuProps): JSX.Element {
  return (
    <div className="flex flex-col p-8 gap-4 rounded-2xl">
      {sections.map((section) => {
        const isRich = isSectionRich(section.items);
        return (
          <div key={section.title}>
            {/* Section header + divider */}
            <div className="flex flex-col gap-2 pt-4 first:pt-0">
              <span className="pb-2 text-sm text-gray-900">
                {section.title}
              </span>
              <div className="h-px bg-gray-200" />
            </div>

            {/* Section items — gap-4 for plain links, gap-6 for rich items */}
            <div className={`flex flex-col ${isRich ? 'gap-6' : 'gap-4'} pt-4`}>
              {section.items.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="flex items-center gap-4 hover:opacity-80"
                >
                  {(item.stockblocksIcon || item.icon) && (
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white shadow-md">
                      <img
                        src={item.stockblocksIcon || item.icon}
                        alt=""
                        width={24}
                        height={24}
                      />
                    </div>
                  )}
                  <div className="flex flex-col gap-0.5">
                    <span className="whitespace-nowrap text-base font-semibold text-gray-900">
                      {item.label}
                    </span>
                    {item.description && (
                      <span
                        className="text-xs text-gray-800"
                        style={{ width: '330px' }}
                      >
                        {item.description}
                      </span>
                    )}
                  </div>
                </a>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
